import generateRandomKey from "@utils/generateRandomKey"

import { TabItem } from "@atoms"

import { TabStack } from "@molecules"

import { BottomSheetItemBase } from "@organisms/BottomSheet/BottomSheetItem/BottomSheetItem"
import useTable from "@organisms/Table/Table.context"

import styles from "./BottomSheetSortingColumns.module.scss"
import { BottomSheetSortingColumnsProps } from "./BottomSheetSortingColumns.types"

export function BottomSheetSortingColumnsList(props: BottomSheetSortingColumnsProps) {
    const { isVisible } = props

    const { sortingEnabledColumns, activeSorting, onSortingItemSelection } = useTable()

    return (
        <div className={styles.sortingColumns}>
            {sortingEnabledColumns.map((column) => (
                <BottomSheetItemBase
                    key={generateRandomKey()}
                    label={column.header as string}
                    onClick={() => onSortingItemSelection(column)}
                    isSelected={activeSorting?.id === column.accessorKey}
                    isTabbable={isVisible}
                />
            ))}
        </div>
    )
}

export function BottomSheetSortingOrderSelector(props: BottomSheetSortingColumnsProps) {
    const { isVisible } = props

    const {
        activeSorting,
        activeSortingIcons,
        activeSortingLabels,
        setCurrentSortToAscending,
        setCurrentSortToDescending,
    } = useTable()

    return (
        <div className={styles.sortingOrderSelector}>
            <TabStack variant="contained" size="md">
                <TabItem
                    icon={activeSortingIcons?.asc}
                    isSelected={!activeSorting?.desc}
                    isTabbable={isVisible}
                    onClick={setCurrentSortToAscending}
                    noDebounce={true}
                >
                    {activeSortingLabels?.asc}
                </TabItem>
                <TabItem
                    icon={activeSortingIcons?.desc}
                    isSelected={activeSorting?.desc}
                    isTabbable={isVisible}
                    noDebounce={true}
                    onClick={setCurrentSortToDescending}
                >
                    {activeSortingLabels?.desc}
                </TabItem>
            </TabStack>
        </div>
    )
}
